import React, { useState } from 'react';
import ConfirmModal from 'components/ConfirmModal';
import { Button } from 'ui-kit';
import SingInOptions from 'components/Account/SignInOptions';
import { useOwnerDetails } from 'api/owners';
import Wrapper from 'components/Wrapper';

export interface ISignInSettingsForm {
  ownerId: number;
}

const SignInSettingsForm = ({ ownerId }: ISignInSettingsForm) => {
  const [deleteConfirmationIsOpen, setDeleteConfirmationIsOpen] = useState(false);

  const { data, invalidate } = useOwnerDetails(ownerId);

  return (
    <>
      <Wrapper className="hc-settings subform">
        <SingInOptions
          socialAuths={data?.user?.socialAuths ?? []}
          hasSetPassword={data?.user?.hasSetPassword}
          onChangeSettings={() => invalidate()}
        />
        <Button
          className="hc-delete-account"
          onClick={() => {
            setDeleteConfirmationIsOpen(true);
          }}
        >
          Delete your account
        </Button>
      </Wrapper>
      <ConfirmModal
        visible={deleteConfirmationIsOpen}
        confirmText="Contact"
        confirmHref="mailto:remove@thehost.co"
        cancelText="Cancel"
        onCancel={() => {
          setDeleteConfirmationIsOpen(false);
        }}
        destroyOnClose
      >
        To delete your account contact us at
        <a style={{ whiteSpace: 'nowrap' }} href="mailto:remove@thehost.co">
          remove@thehost.co
        </a>
      </ConfirmModal>
    </>
  );
};

export default SignInSettingsForm;
